module.exports = __webpack_public_path__ + "img/volvo_exit.936d50be.svg";